module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Tag",
    class: _vm.classes
  }, [(_vm.icon) ? _c('div', {
    staticClass: "Tag-icon"
  }, [_c('icon', {
    attrs: {
      "name": _vm.icon
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.label) ? _c('div', {
    staticClass: "Tag-label"
  }, [_vm._v("\n    " + _vm._s(_vm.label) + "\n  ")]) : _vm._e(), _vm._v(" "), (_vm.meta) ? _c('div', {
    staticClass: "Tag-meta"
  }, [_vm._v("\n    " + _vm._s(_vm.meta) + "\n  ")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c916aaaa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tag.vue
// module id = 794
// module chunks = 1474